// import { useOrgStore } from '@/stores/org-store';
import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '../../utils/api-request';
import {
  CollectionDataType,
  CollectionSource,
  CollectionSourceConfig,
} from '@/types/source-types';

interface CreateCollectionResponse {
  data?: {
    status: 'success' | 'error';
    message: string;
    organization_id: string;
    id: string;
  };
  detail?: string;
}

interface CreateCollectionProps {
  id?: string;
  collectionName: string;
  collectionType: CollectionDataType;
  source?: CollectionSource;
  sourceConfig?: CollectionSourceConfig | null;
}

export const createCollection = async ({
  id = '',
  collectionName,
  collectionType,
  source,
  sourceConfig,
}: CreateCollectionProps): Promise<CreateCollectionResponse> => {
  const orgId = id || useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }
  /**
   * todo: check platform-api /qdrant-clusters/{orgId} for any existing dedicated clusters provisioned for the org (uncommon)
   * User can select a cluster if available, otherwise default to the first one.
   * This cluster_id (uuid) can be added to the body payload for platform-api to map it as the destination.
   */
  const isStructured = collectionType === 'structured';

  const payload: Record<string, unknown> = {
    name: collectionName,
    orgid: orgId,
    destination: isStructured ? 'analytics' : 'qdrant',
    data_type: collectionType,
  };

  if (source) {
    payload.source = source;
  }

  if (sourceConfig) {
    const cleanedConfig = JSON.parse(JSON.stringify(sourceConfig));
    if (Object.keys(cleanedConfig).length) {
      payload.source_config = cleanedConfig;
    }
  }

  const response = await apiRequest<CreateCollectionResponse>({
    url: `/collections/${orgId}`,
    method: 'POST',
    body: payload,
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to create data collection',
    };
  }

  return response as CreateCollectionResponse;
};
